export default __webpack_public_path__ + "static/media/fridge1-before1-2048w.3c2e9d56.avif";